import * as atoms from '.'

const Converdy = {
  install (Vue) {
    Object.values(atoms).forEach(
      atom => {
        Vue.component(
          atom.name,
          atom
        )
      }
  )
  }
}

export default Converdy

export function ConverdyWithPrefix (prefix = '') {
  return {
    install (Vue) {
      Object.values(atoms).forEach(
        atom => {
          Vue.component(
            prefix + atom.name,
            atom
          )
        }
      )
    }
  }
}
